import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import CompanyNavbar from 'components/Navbars/CompanyNavbar'
import BusinessList from 'components/Lists/BusinessList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { FaPlus } from 'react-icons/fa'
import { Container, LinkButton, InfoText } from './styles'

export default function Businesses () {
  const [loading, setLoading] = useState (true)
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [businesses, setBusinesses] = useState ([])
  const company = AuthService.getUser ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getBusinesses (1)
  }, [])

  const getBusinesses = async (pageNumber = page) => {
    if (lastPage && pageNumber > lastPage) return

    try {
      if (pageNumber === 1) setLoading (true)
      const filters = `page=${pageNumber}&company_id=${company.id}`

      const { data: businessesResponse } = await cutileiApi.get (`/businesses?${filters}`, requestConfig)
      const { data, meta } = businessesResponse
      const businessesData = pageNumber > 1 ? [...businesses, ...data] : data

      setBusinesses (businessesData)
      setPage (pageNumber + 1)
      setLastPage (meta.last_page)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container>
      <CompanyNavbar/>
      <LinkButton to='/signup' state={{ company_id: company.id }}>
        <FaPlus size={12} color='#FFC100'/>
        Cadastrar salão
      </LinkButton>
      {businesses.length === 0 && !loading && (
        <InfoText>
          Sua empresa ainda não possui um salão cadastrado
        </InfoText>
      )}
      {loading ? <Loading/> : (
        <BusinessList
          businesses={businesses}
          hasMore={!(lastPage && page > lastPage)}
          onScroll={getBusinesses}
        />
      )}
    </Container>
  )
}
